import { Box, Grid, Typography } from "@material-ui/core";

import { COLORS } from "../../../theme/colors";
import { getConditionalText, nKilowattFormatter } from "../../../services";

export const SummaryBox = ({ text, roof, parkingLots, unitMeasurement = "kWh" }) => {
  const suffix = unitMeasurement[2];

  const getTotal = () => {
    let total = null;
    let uMeasurement = null;

    if (roof !== null && parkingLots === null) {
      total = roof;
    } else if (roof === null && parkingLots !== null) {
      total = parkingLots;
    } else if (roof !== null && parkingLots !== null) {
      total = roof + parkingLots;
    }

    if (total !== null) {
      const formattedValue = nKilowattFormatter(total, suffix);
      [total, uMeasurement] = formattedValue.split(" ");
    }

    total = getConditionalText(total !== null, total);

    return [total, uMeasurement];
  };
  const [total, uMeasurement] = getTotal();
  return (
    <Box py={3} px={4}>
      <Typography>{text}</Typography>
      <Grid container alignItems="baseline" style={{ columnGap: 40 }}>
        <Grid container alignItems="baseline" style={{ columnGap: 4, width: "fit-content" }}>
          <Typography variant="h2" style={{ color: COLORS.green }}>
            Total {total}
          </Typography>
          <Typography style={{ color: COLORS.green }}>{uMeasurement}</Typography>
        </Grid>
        <Grid container style={{ columnGap: 20, width: "fit-content" }}>
          <Typography>
            <b>Roof</b> {getConditionalText(roof !== null, nKilowattFormatter(roof))}
          </Typography>
          <Typography>
            <b>Parking lots</b>{" "}
            {getConditionalText(parkingLots !== null, nKilowattFormatter(parkingLots))}
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
};
